import { Module } from '../../../ts/Module';

export class FocusCtrl {

  private $element: JQuery;

  constructor() {
  }

  public setFocusElement(elm: JQuery) {
    this.$element = elm;
  }

  public focus() {
    this.$element.focus();
  }

  public hasFocusElement(): boolean {
    return !!this.$element;
  }
}

Module.instance().controller('FocusCtrl', FocusCtrl);
